export enum LabelDrawableType {
  TEXT = "TEXT",
  BARCODE = "BARCODE",
  QR_CODE = "QR_CODE",
  SHAPE = "SHAPE",
}

export enum LabelDrawableAlign {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

export enum LabelDrawableBarcodeSymbology {
  EAN13 = "EAN13",
  EAN8 = "EAN8",
  CODE39 = "CODE39",
  CODE128 = "CODE128",
  ITF = "ITF",
}

export enum LabelDrawableRotation {
  ROTATE_0 = "0",
  ROTATE_90 = "90",
  ROTATE_180 = "180",
  ROTATE_270 = "270",
}
